import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { hidePartnerfriedhoefeNav } from '../config/ui-flags';

export const partnerfriedhoefeAvailabilityGuard: CanActivateFn = () => {
  if (hidePartnerfriedhoefeNav) {
    inject(Router).navigate(['/dash/burials']);
    return false;
  }
  return true;
};
